import Link from '@components/common/Link/Link'
import Media from '@components/ui/Media/Media'
import { InspirationElementFragment } from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'
import s from './TrendGridItem.module.scss'

const TrendGridItem: React.FC<
  InspirationElementFragment & { large?: boolean; itemIndex: number }
> = ({ teaser, heading, image, link, large, itemIndex }) => {
  return (
    <Link link={link}>
      <div className={s.root}>
        <div className={s.image} data-large={large}>
          {image && (
            <Media
              mediaWithCrops={image}
              scaleOnHover
              disableShopTheLook
              mediaClassName={clsx(s.media, { [s.large]: large })}
            />
          )}
        </div>
        <div className={clsx(s.content, { [s.paddedLeft]: itemIndex === 0 })}>
          {teaser && <div className={s.heading}>{teaser}</div>}

          <h3 className={clsx(s.subHeading)}>{heading}</h3>
        </div>
      </div>
    </Link>
  )
}

export default TrendGridItem
